<template>

<div v-if="needForgotPasswordLogin">
        <form class="login-form" name="forgotPasswordForm" autocomplete="nope"  v-if="!phoneNumberEmailSuccess" novalidate>
            <img src="./../assets/images/forget-pass.png" class="forget-pass-image" />
            <p class="m-b-40 m-t-20">Tell us your phone number or email or username.We will send the reset password link.</p>
            
            <div class="input-group m-b-20">
                <input  type="text" name="phoneNumberorEmail" class="form-control" v-model="user.email" v-on:focus="dataFocus=true" v-on:blur="dataFocus=false" required>
                <div class="input-label" v-bind:class="{ active: dataFocus || user.email }">Phone or Email ID or UserName</div>
            </div>

            <div>
                <button type="button" class="btn btn-primary btn-block m-t-10" v-bind:disabled="!user.email" @click="getForgotPassword(user)">Send Reset Link</button>
            </div>
        </form>
        <form class="login-form" name="otpForgotPasswordForm" @submit="getForgotPasswordLogin()" v-if="phoneNumberEmailSuccess" novalidate>
            <p>Reset password link successfully sent to your registered email address.</p>
        </form>
    </div>
</template>

<script>
export default {

  name: 'ForgotPassword',
  props: ['needForgotPasswordLogin', 'phoneNumberEmailSuccess'],
  data () {
    return {
        user : {
            email : ''
        },
        dataFocus : false
    }
  },
  methods: {
      getForgotPassword(user){
          
          this.$emit('forgotPassword', user.email);
      }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/ForgotPassword.vue